// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Poppins-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: Poppins-Light;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
}
@font-face {
	font-family: Poppins-Thin;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); 
}
@font-face {
	font-family: Poppins-Regular;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); 
}
@font-face {
	font-family: Poppins-Medium;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); 
}
@font-face {
	font-family: Poppins-SemiBold;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); 
}
@font-face {
	font-family: Poppins-Bold;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); 
}

/* Ensure tooltips appear above modals */
.tooltip {
  z-index: 99999 !important;
}

.tooltip.show {
  opacity: 1;
}

.tooltip-inner {
  max-width: 300px;
  padding: 8px 12px;
  background-color: #333;
  color: white;
  text-align: center;
  border-radius: 4px;
  /* font-size: 13px; */
  line-height: 1.4;
}

/* .bs-tooltip-auto[x-placement^=top] .arrow::before, 
.bs-tooltip-top .arrow::before {
  border-top-color: #333;
} */`, "",{"version":3,"sources":["webpack://./src/Utility/Public/css/theme.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,4CAAsC;AACvC;AACA;CACC,yBAAyB;CACzB,4CAAqC;AACtC;AACA;CACC,4BAA4B;CAC5B,4CAAwC;AACzC;AACA;CACC,2BAA2B;CAC3B,4CAAuC;AACxC;AACA;CACC,6BAA6B;CAC7B,4CAAyC;AAC1C;AACA;CACC,yBAAyB;CACzB,4CAAqC;AACtC;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;GAGG","sourcesContent":["@font-face {\n\tfont-family: Poppins-Light;\n\tsrc: url('../fonts/Poppins-Light.ttf'); \n}\n@font-face {\n\tfont-family: Poppins-Thin;\n\tsrc: url('../fonts/Poppins-Thin.ttf'); \n}\n@font-face {\n\tfont-family: Poppins-Regular;\n\tsrc: url('../fonts/Poppins-Regular.ttf'); \n}\n@font-face {\n\tfont-family: Poppins-Medium;\n\tsrc: url('../fonts/Poppins-Medium.ttf'); \n}\n@font-face {\n\tfont-family: Poppins-SemiBold;\n\tsrc: url('../fonts/Poppins-SemiBold.ttf'); \n}\n@font-face {\n\tfont-family: Poppins-Bold;\n\tsrc: url('../fonts/Poppins-Bold.ttf'); \n}\n\n/* Ensure tooltips appear above modals */\n.tooltip {\n  z-index: 99999 !important;\n}\n\n.tooltip.show {\n  opacity: 1;\n}\n\n.tooltip-inner {\n  max-width: 300px;\n  padding: 8px 12px;\n  background-color: #333;\n  color: white;\n  text-align: center;\n  border-radius: 4px;\n  /* font-size: 13px; */\n  line-height: 1.4;\n}\n\n/* .bs-tooltip-auto[x-placement^=top] .arrow::before, \n.bs-tooltip-top .arrow::before {\n  border-top-color: #333;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
